import ACTIONS from "./actions";

const initialState = {
  isLoading: false,
  isError: false,
  siteId: null,
};

function siteIdReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.FETCH_SITE_ID_INIT:
      return { ...state, isLoading: true, isError: false };
    case ACTIONS.FETCH_SITE_ID_SUCCESS:
      return { ...state, isLoading: false, isError: false, siteId: action.payload };
    case ACTIONS.FETCH_SITE_ID_FAILURE:
      return { ...state, isLoading: false, isError: true, siteId: null };
    default:
      return state;
  }
}

export default siteIdReducer;
